module.exports = __webpack_public_path__ + "static/img/sub_page_banner_2.c039200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sub_page_banner_2.jpg
// module id = 22Cu
// module chunks = 0